// pdfWorker.js
import html2pdf from "html2pdf.js";

const generatePdf = async (content, filename) => {
  try {
    const pdfBlob = await html2pdf().from(content).outputPdf();
    return { filename, pdfBlob };
  } catch (error) {
    console.error("PDF generation error:", error);
    throw error;
  }
};

export default generatePdf;
